// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__+qutZ","active":"Circle_active__QQgOC"};